import React from 'react'
import AccordionContext from 'support/utilities/accordions/contexts/AccordionContext'

export default function Accordion ({ children, allowMultipleOpen = false, defaultOpen = false }) {
  const [active, setActive] = React.useState([])

  // todo: implement only allow single accordion to be open

  const open = (name) => setActive((oldActive) => [...oldActive, name])
  const close = (name) => setActive((oldActive) => oldActive.filter((active) => active !== name))
  const toggle = (name) => active.includes(name) ? accordion.close(name) : accordion.open(name)
  const isActive = (name) => active.includes(name)

  const accordion = {
    open,
    close,
    toggle,
    isActive
  }

  return (
    <AccordionContext.Provider value={accordion}>
      {children}
    </AccordionContext.Provider>
  )
}
